import React from "react";
import {PagePreloader} from "components/Preloader";
import {useSelector} from "react-redux";
import {getGlobalLoaderStateSelector} from "modules/selectors";

export const GlobalPreloader: React.FC = () => {
	const isGlobalLoader = useSelector(getGlobalLoaderStateSelector);
	return isGlobalLoader ? <PagePreloader /> : null;
};
